module.exports = __webpack_public_path__ + "static/assets/c97dc074c1b113aa15f766ee958ee8c9.png";